import React from 'react';
import styles from './circle-image.module.scss';

interface CircleImageProps {
  onClick?: () => void;
  imgSrc?: string;
  imgSize: number;
}

export const CircleImage: React.FC<CircleImageProps> = ({
  onClick,
  imgSrc,
  imgSize,
}) => {
  const EditIcon = () => (
    <div
      className={styles.icon__container}
      style={{ width: imgSize / 2, height: imgSize / 2 }}
    >
      <svg
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.icon}
        style={{ width: imgSize / 4, height: imgSize / 4 }}
      >
        <path
          d="M16.1298 0.982765C15.8392 0.677137 15.4903 0.432758 15.1037 0.264021C14.7172 0.0952843 14.3008 0.00560115 13.879 0.000254083C13.4573 -0.00509298 13.0387 0.0740042 12.648 0.232887C12.2573 0.391769 11.9023 0.627224 11.604 0.925385L1.64176 10.8871C1.29355 11.2352 1.05174 11.6753 0.944668 12.1559L0.0127312 16.3531C-0.00671543 16.4403 -0.00384514 16.531 0.0210762 16.6169C0.0459975 16.7027 0.0921646 16.7808 0.155305 16.8441C0.218446 16.9073 0.296521 16.9536 0.382303 16.9787C0.468086 17.0037 0.558805 17.0068 0.646066 16.9875L4.81906 16.0598C5.31578 15.9492 5.77066 15.6993 6.13036 15.3394L16.0746 5.39569C16.6574 4.81259 16.9894 4.02485 16.9998 3.20047C17.0101 2.37608 16.6979 1.58028 16.1298 0.982765ZM12.3553 1.67663C12.5497 1.47947 12.7811 1.32271 13.0364 1.21538C13.2916 1.10806 13.5655 1.05229 13.8424 1.0513C14.1193 1.05031 14.3936 1.10411 14.6496 1.2096C14.9056 1.31509 15.1382 1.47019 15.334 1.66596C15.5297 1.86173 15.6848 2.0943 15.7903 2.35027C15.8958 2.60625 15.9496 2.88056 15.9486 3.15742C15.9476 3.43428 15.8919 3.70821 15.7845 3.96342C15.6772 4.21863 15.5205 4.45008 15.3233 4.64444L14.6102 5.35744L11.6423 2.39069L12.3553 1.67663ZM10.891 3.14301L13.859 6.10975L5.37907 14.5892C5.16224 14.8063 4.88798 14.9571 4.58847 15.0238L1.23052 15.7697L1.98287 12.3875C2.04556 12.1038 2.18796 11.8445 2.39305 11.6395L10.891 3.14301Z"
          fill="#535761"
        />
      </svg>
    </div>
  );
  return (
    <div
      className={`${styles.default_image__container} ${onClick ? styles.clickable : ''}`}
      onClick={onClick}
      style={{ width: imgSize, height: imgSize }}
    >
      {imgSrc ? (
        <img
          className={
            onClick ? styles.info__image_clickable : styles.info__image
          }
          src={imgSrc}
        />
      ) : (
        <div className={styles.info__image__not_found}></div>
      )}

      {onClick && <EditIcon />}
    </div>
  );
};
